const InitialState = null

const CarsData = (state = InitialState, action) => {
    switch (action.type) {
        case "ADD_CARS_DATA":
            return state = action.data
            break;
        default:
            return state
            break;
    }

}

export default CarsData